import { render, staticRenderFns } from "./PersonsEditPanel.vue?vue&type=template&id=21dac192"
import script from "./PersonsEditPanel.vue?vue&type=script&lang=js"
export * from "./PersonsEditPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports